module.exports = __webpack_public_path__ + "static/media/8.d46d3471.jpg";